import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useState } from 'react';
import {
  BranchTableData,
  HighOverviewReportTypeRes,
} from '../../../../api/types/reports/high-overview/high-overview.type';

export interface HighLevelOverviewGeneralBranchInformationDatamodel {
  data: HighOverviewReportTypeRes | undefined;
}

export const HighLevelOverviewGeneralBranchInformation: React.FC<
  HighLevelOverviewGeneralBranchInformationDatamodel
> = ({ data }) => {
  return (
    <div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        value={data?.generalBranchTableDetailsAndData || []}
        responsiveLayout="scroll"
        className="branch-metrics-table"
      >
        <Column
          style={{ textAlign: 'right' }}
          field="branchName"
          header="שלוחה"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="studentNumber"
          header="מספר סטודנטים"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="professorsNumber"
          header="מספר מרצים"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="programsNumber"
          header="מספר תוכניות פעילות"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="coursesNumber"
          header="מספר קורסים"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="hoursNumberTeaching"
          header="מספר שעות ששובצו"
          sortable
          body={(rowData: BranchTableData) => (
            <label>
              {Math.round((rowData.hoursNumberTeaching || 0) * 10) / 10}
            </label>
          )}
        />
      </DataTable>
    </div>
  );
};
